export default {
  'creativeVideo.filter.status.all': '全部状态',
  'creativeVideo.filter.status.running': '生成中',
  'creativeVideo.filter.status.success': '成功',
  'creativeVideo.filter.status.fail': '失败',
  'creativeVideo.empty': '暂无视频',
  'creativeVideo.loadFailed': '视频列表加载失败',
  'creativeVideo.loadingMore': '加载更多…',
  'creativeVideo.noMore': '没有更多了',
  'creativeVideo.download': '下载',
  'creativeVideo.recreate': '重新创作',
  'creativeVideo.downloadFailed': '下载失败',
  'creativeVideo.delete': '删除',
  'creativeVideo.deleteSuccess': '删除成功',
  'creativeVideo.deleteFailed': '删除失败，请重试',
  'creativeVideo.noPreview': '暂无可预览视频',
  'creativeVideo.copyPromptSuccess': '复制成功',
  'creativeVideo.copyPromptFailed': '复制失败',
  'creativeVideo.meta.refImage': '参考图',
  'creativeVideo.meta.refVideo': '参考视频',
  'creativeVideo.meta.firstFrame': '首帧图',
  'creativeVideo.meta.lastFrame': '尾帧图',
};
